module.exports = __webpack_public_path__ + "static/JeffreyNiesen-8e1a4efe8d3d27e193e62d118ccae512.jpg";